"use client";
import Link from "next/link";
import { ArrowRight } from "lucide-react";
import { Section, Container } from "@/components/ui/container";
import { Reveal } from "@/components/ui/reveal";
import { supportTiers as data } from "@/lib/data/support";

const tierAccents = ["var(--color-crimson)", "var(--color-cyan)", "var(--color-amber)"];

export function SupportTiers() {
  return (
    <Section id="support-tiers" className="relative">
      <Container>
        <Reveal>
          <div className="max-w-3xl">
            <span className="eyebrow-tiny text-[var(--color-crimson)]">{data.eyebrow}</span>
            <h2 className="mt-3">{data.title}</h2>
            <p className="mt-5 text-body text-[rgb(var(--fg-muted))] leading-relaxed">{data.intro}</p>
          </div>
        </Reveal>
        <Reveal delay={100}>
          <div className="mt-10 glass rounded-2xl overflow-hidden">
            <div className="overflow-x-auto">
              <table className="w-full text-sm">
                <thead>
                  <tr className="border-b border-[rgb(var(--border)/0.18)] bg-[rgb(var(--border)/0.04)]">
                    <th className="text-left px-4 py-3 eyebrow-tiny text-[rgb(var(--fg-subtle))]">Feature</th>
                    <th className="text-left px-4 py-3 eyebrow-tiny" style={{ color: tierAccents[0] }}>Standard</th>
                    <th className="text-left px-4 py-3 eyebrow-tiny" style={{ color: tierAccents[1] }}>Professional</th>
                    <th className="text-left px-4 py-3 eyebrow-tiny" style={{ color: tierAccents[2] }}>Enterprise</th>
                  </tr>
                </thead>
                <tbody>
                  {data.rows.map((row) => (
                    <tr key={row.feature} className="border-b border-[rgb(var(--border)/0.08)]">
                      <td className="px-4 py-3 align-top font-medium">{row.feature}</td>
                      <td className="px-4 py-3 align-top text-[rgb(var(--fg-muted))]">{row.standard}</td>
                      <td className="px-4 py-3 align-top text-[rgb(var(--fg-muted))]">{row.professional}</td>
                      <td className="px-4 py-3 align-top text-[rgb(var(--fg-muted))]">{row.enterprise}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </Reveal>
        <Reveal delay={200}>
          <div className="mt-8 grid sm:grid-cols-3 gap-4">
            {data.guidance.map((g, i) => {
              const c = tierAccents[i % tierAccents.length]!;
              return (
                <div key={g.tier} className="glass rounded-2xl p-5" style={{ boxShadow: `inset 0 0 0 1px color-mix(in oklch, ${c} 18%, transparent)` }}>
                  <span className="eyebrow-tiny font-bold" style={{ color: c }}>{g.tier}</span>
                  <p className="mt-3 text-sm text-[rgb(var(--fg-muted))] leading-relaxed">{g.body}</p>
                </div>
              );
            })}
          </div>
        </Reveal>
        <Reveal delay={500}>
          <div className="mt-8 flex flex-wrap items-center gap-3">
            {data.cta.map((c, i) => (
              <Link key={c.label} href={c.href} className={i === 0 ? "btn-primary-gradient h-11 px-6 inline-flex items-center gap-2 rounded-full font-semibold text-sm" : "btn-glass h-11 px-6 inline-flex items-center gap-2 rounded-full font-semibold text-sm"}>
                {c.label} <ArrowRight className="h-3.5 w-3.5" />
              </Link>
            ))}
          </div>
        </Reveal>
      </Container>
    </Section>
  );
}
